import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

function Accept(props) {
  const cookieAccepted = sessionStorage.getItem("cookieAccepted");
  const [showAccept, setShowAccept] = useState(false);

  useEffect(() => {
    console.log("cookieAccepted", cookieAccepted);
    if (cookieAccepted && cookieAccepted === "true") {
      setShowAccept(true);
      // 动态创建 script 标签  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-525965648"></script>
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=AW-525965648";
      document.body.appendChild(script);
    }
  }, []);

  const acceptFn = () => {
    sessionStorage.setItem("cookieAccepted", "true");
    window.location.reload();
  };

  const rejcetFn = () => {
    setShowAccept(true);
  };

  return !showAccept ? (
    <AcceptStyle>
      <div className="accept">
        <p className="accept-title">Cookie Usage.</p>
        <div className="accept-content">
          <p>
            We use cookies, including third-party cookies, for analytical
            purposes and to show you personalised advertising based on your
            browsing habits. By clicking on "Accept all" you agree to the saving
            and reading of information on your end device.
          </p>
          <p>
            You also agree to the further processing of the collected and read
            personal data, in addition to the possible transfer to countries
            outside of the extended EU (EU + CH, IS, LI, NO, UK), for example
            the US.
          </p>
          <p>
            By clicking on "Reject" you reject the use of cookies that require
            consent.
          </p>
        </div>
        <div className="accept-buttons">
          <button className="reject-button btns" onClick={rejcetFn}>
            Reject
          </button>
          <button className="accept-btns btns" onClick={acceptFn}>
            Accept
          </button>
        </div>
      </div>
    </AcceptStyle>
  ) : null;
}

export default Accept;

const AcceptStyle = styled.div`
  width: 100%;
  position: sticky;
  left: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 9999;
  box-shadow: 0px 0 14px rgba(0, 0, 0, 0.3);
  .accept {
    padding: 20px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    .accept-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .accept-content {
      width: 100%;
      p {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 10px;
        text-align: left;
      }
    }
    .accept-buttons {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .btns {
        width: 200px;
        height: 52px;
        border-radius: 4px;
        border: 1px solid #000;
        background-color: #fff;
        cursor: pointer;
        margin: 0 20px;
      }
      .btns.accept-btns {
        background-color: #1c69d4;
        color: #fff;
        border-color: #1c69d4;
      }
    }
  }
`;
